<template>
  <div v-if="cameras.length && hasPermission">
    <label>
      <select v-model="model"
              class="video-room-select-field"
      >
        <option value="" selected disabled hidden>{{ $t('selectCamera') }}</option>
        <option v-for="(camera,index) in cameras" :key="index" :value="camera.deviceId">
          {{ camera.label || `camera ${index + 1}` }}
        </option>
      </select>
    </label>
    <slot />
  </div>
</template>

<script>
import useCamera from '@/compositions/useCamera';
import {
  computed, onMounted, ref,
} from '@vue/composition-api';
import useStreams from '@/compositions/useStreams';

export default {
  name: 'CameraSelector',
  setup(props, { emit }) {
    const {
      cameras, loadCameras,
    } = useCamera();
    const { cameraId } = useStreams();
    const selected = ref(null);
    const model = computed({
      get: () => selected.value || cameraId.value || '',
      set: (val) => {
        selected.value = val;
        emit('selected', selected.value);
      },
    });
    const hasPermission = computed(() => cameras.value.length > 0 && cameras.value[0].deviceId);

    onMounted(async () => {
      await loadCameras();
    });

    return {
      selected,
      model,
      cameras,
      hasPermission,
    };
  },
};
</script>

<style lang="scss" scoped>
.video-room-select-field {
  width: 21.5rem;
  max-width: 100%;
  background: #FFFFFF url("../assets/img/icons/select.svg") no-repeat 96% 0.875rem;
  border: 1px solid #E0E0E0;
  border-radius: 0.25rem;
  padding: 0.375rem 2rem 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.43;
  color: #757575;
  margin-bottom: 0.125rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: relative;
  cursor: pointer;
  &:focus {
    border-color: #0a82d9;
    outline: none;
  }
}
@media (max-width: 374px) {
  .video-room-select-field {
    width: 17.5rem;
  }
}
</style>

<i18n locale="en" lang="yaml">
selectCamera: Select camera
</i18n>

<i18n locale="ru" lang="yaml">
selectCamera: Выберите камеру
</i18n>
